import { atom } from "recoil";

export const productOptionState = atom({
  key: "productOptionState",
  default: [],
});
